<template>
  <div>
    <div :class="s.wrap">
      <div v-if="data.showOrderResultForm && !flag.registedOrderResult">
        <div>
          <div class="d-flex align-items-center">
            <p class="fw-bold">確定料金</p>
            <div :class="s.buttons" class="ms-auto me-0">
              <button :class="[s.blue, s.mt_0]" @click="reCalculateFare">再計算</button>
            </div>
          </div>
          <div :class="s.type">
            <input :class="s.input" type="text" v-model="priceInput" @input="onPriceInput">
            <span :class="s.unit">円</span>
          </div>
        </div>
        <div class="mt-2">
          <div class="d-flex align-items-center">
            <p class="fw-bold">乗車人数</p>
          </div>
          <div :class="s.type">
            <select :class="s.select" v-model="passengerCount">
              <option :class="s.input" v-for="cap in capacities" :key="cap" :value="cap">{{ cap }}</option>
            </select>
            <span :class="s.unit">人</span>
          </div>
        </div>
        <div class="mt-2" v-if="tickets.length">
          <div class="d-flex align-items-center">
            <p class="fw-bold">チケット利用</p>
          </div>
          <div :class="s.type">
            <select :class="[s.select, s.left]" v-model="selectedTicketId">
              <option :value="null">利用された場合は選択してください</option>
              <option v-for="ticket in tickets" :key="ticket" :value="ticket.id">{{ ticket.label }}</option>
            </select>
          </div>
        </div>
        <div class="mt-2">
          <div class="d-flex align-items-center">
            <p class="fw-bold">身体障害者割引</p>
          </div>
          <div :class="s.type">
            <input type="checkbox" :class="s.checkbox" :true-value="1" :false-value="0" v-model="isDiscounted">
          </div>
        </div>
        <div class="mt-2">
          <div class="d-flex align-items-center">
            <p class="fw-bold">支払い金額</p>
          </div>
          <div :class="s.type">
            <p class="fw-bold fs-3">{{ formatPrice(Math.ceil(discountedPrice) || 0) }}<span :class="s.unit">円</span></p>
          </div>
        </div>
        <div class="mt-3">
          <div class="d-flex align-items-center">
            <div :class="s.buttons" class="mx-auto">
              <button @click="updateOrderResult" :class="s.green" :disabled="!price || !passengerCount">確定</button>
              <button v-if="!data.id" @click="completedOrderResult" :class="s.gray">あとで登録</button>
              <button v-else @click="hideModal({ type: 'cancel' })" :class="s.gray">キャンセル</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="(data.showThanksMessage && flag.registedOrderResult) || !data.showOrderResultForm">
        <div>
          <p class="text-center fs-xl">お疲れ様でした！</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'order-result',
  props: ['data'],
  data() {
    return {
      flag: {
        registedOrderResult: false,
      },
      price: 0,
      priceInput: '',
      passengerCount: 1,
      tickets: [],
      selectedTicketId: null,
      isDiscounted: 0,
    };
  },
  created() {
    this.getTickets();
    if (this.data.price) {
      this.price = this.data.price;
      this.priceInput = this.formatPrice(this.price) || 0;
    }
    if (this.data.capacity) this.passengerCount = this.data.capacity;
    if (this.data.ticketId) this.selectedTicketId = this.data.ticketId;
    if (this.data.isDiscounted) this.isDiscounted = this.data.isDiscounted;
    if (!this.data.showOrderResultForm && this.data.showThanksMessage) {
      this.completedOrderResult();
    }
    // if (this.data.capacity) this.passengerCount = this.data.capacity;
  },
  computed: {
    ...mapState(['user']),
    capacities() {
      return Array.from({ length: 5 }, (v, k) => k + 1);
    },
    officeId() {
      return this.user?.offices?.[0]?.id || null;
    },
    discountedPrice() {
      if (!this.price || this.selectedTicketId) return 0;
      if (this.isDiscounted) return this.price * 0.9; // 身体障害者割引は10%OFF
      return this.price;
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getTickets() {
      if (!this.officeId) {
        alert('初期化に失敗しました。\n再度お試しください。');
        this.hideModal({ type: 'cancel' });
        return;
      }

      const params = {
        flags: [1],
        officeIds: [this.officeId],
      };

      this.axios({
        method: 'GET',
        url: '/v1/ticket/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          if (res.tickets?.data?.length) {
            this.tickets = res.tickets.data;
          }
          // } else {
          //   alert('チケット情報が取得できませんでした。\n再度お試しください。');
          //   this.hideModal({ type: 'cancel' });
          // }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          console.log(error);
        });
    },
    onPriceInput(event) {
      let value = event.target.value;

      // 1. 全角・半角の数字以外を除去
      value = value.replace(/[^0-9０-９]/g, '');

      // 2. 全角数字を半角数字に変換
      value = value.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));

      const numericValue = parseInt(value, 10);
      this.price = isNaN(numericValue) ? 0 : numericValue;
      this.priceInput = this.formatPrice(this.price);
    },

    /** 数値をカンマ区切りの文字列に変換 */
    formatPrice(value) {
      return value.toLocaleString('ja-JP');
    },
    hideModal(actionType) {
      const payload = {
        type: actionType.type,
        data: {},
      };
      if (actionType.type === 'update') {
        payload.data = {
          type: 'orderResultUpdate',
          order: { id: this.data.orderId },
        };
      }
      this.$store.dispatch('modal/contents/hideModal', payload, { root: true });
      this.hideLoading();
    },
    reCalculateFare() {
      this.axios({
        method: 'GET',
        url: '/v1/order/get/reCalculateFare',
        params: {
          order_id: this.data.orderId,
        },
      })
        .then((response) => {
          const res = response.data;
          if (res.fare) {
            this.price = res.fare;
            this.priceInput = this.formatPrice(this.price);
          } else {
            alert('エラーが発生しました。再度お試しください。');
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
        });
    },
    completedOrderResult() {
      this.hideLoading();
      if (this.data.showThanksMessage) {
        this.flag.registedOrderResult = true;
        // 3秒後にモーダルを閉じる
        setTimeout(() => {
          this.hideModal({ type: 'update' });
        }, 3000);
      } else {
        this.hideModal({ type: 'update' });
      }
    },
    updateOrderResult() {
      if (!Number.isInteger(this.price)) alert('料金は数字で入力してください');
      this.showLoading();
      const data = {
        order_id: this.data.orderId,
        price: this.price,
        passenger_count: this.passengerCount,
        ticket_id: this.selectedTicketId,
        is_discounted: this.isDiscounted,
      };
      if (this.data.id) {
        data.id = this.data.id;
      }

      const endpoint = this.data.id ? 'update' : 'create';
      this.axios({
        method: 'POST',
        url: `/v1/orderResult/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.orderResultId || res.updated) {
            this.completedOrderResult();
          } else {
            alert('エラーが発生しました。再度お試しください。');
            this.hideLoading();
          }
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。再度お試しください。');
          this.hideLoading();
        });
    },
  },
};
</script>
<style lang="scss" module="s">
.wrap {
  padding: 10px 15px;
}
.buttons {
  height: 100%;
  text-align: center;
  > * {
    border: none;
    background-color: transparent;
    padding: 0 16px;
    margin: 8px 4px 0;
    height: 100%;
    font-weight: bold;
    border-radius: 4px;
    &.mt_0 {
      margin-top: 0;
    }
    &.blue {
      background-color: var(--primary-blue);
      color: white;
    }
    &.gray {
      background-color: var(--bs-gray);
      color: white;
    }
    &.green {
      background-color: #20C997;
      color: white;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}
.type {
  display: flex;
  align-items: baseline;
  .input {
    width: 95%;
    height: 50px;
    font-size: 24px;
    text-align: right;
    padding-right: 15px;
    margin-top: 8px;
    border: 1px solid var(--bs-gray);
    border-radius: 3px;
  }
  .select {
    width: 95%;
    height: 50px;
    font-size: 24px;
    text-align: right;
    padding: 0px 15px 0px 8px;
    margin-top: 8px;
    border: 1px solid var(--bs-gray);
    border-radius: 3px;
    &.left {
      text-align: left;
    }
  }
  .checkbox {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: left;
    margin-top: 8px;
  }
  .unit {
    font-size: 18px;
    font-weight: bold;
    margin-left: 10px;
  }
}
</style>
